@if (formField(); as field) {
  <app-input-email
    [color]="hasError() ? 'red' : 'primary'"
    [label]="field.label"
    [(value)]="value"
    [disabled]="field.disabled!"
    [required]="field.required!"
    [readonly]="field.readonly!"
    [labelPosition]="field.labelPosition!"
    [placeholder]="_placeholder()"
  />
}
